import request from "@/utils/request";

// 登入
export const getLogin = (data) => {
  return request.post("login/user_acc-login_pass", data);
};
// 注册
export const getRegister = (data) => {
  return request.post("login/user_acc-register_user", data);
};

//   验证码
export const getMsg = (data) => {
  return request.post("login/user_acc-get_msg_code", data);
};
